import { trpc } from '@/shared/api/trpc';

export const useSetTemporaryPassword = () =>
  trpc.accounts.setTemporaryPassword.useMutation();
